// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  environmentName: 'testing',
  appid: '71101c42-9d12-4ee4-b791-3e8991bcff38',
  clientToken: 'pub0db1047f76bb25ec3fa373abce761d32',
  portalURL: 'https://controllerapi-testing02.input4you.be',
  controllerAPI: 'https://controllerapiv3-testing02.input4you.be',
  apiUrl: 'https://fileservice-testing02.input4you.be/api/', //production link // TODO change name
  loginUrl: 'https://login.input4you.be/LoginAPI/',
  viewerURL: 'https://viewer-testing.input4you.be',
  searchUrl: 'https://search-testing02.input4you.be',
  queueRelay: 'https://queue-relay-testing02.input4you.be',
  notifierUrl: 'https://i4y-dev-notifier.ew.r.appspot.com/notifier',
  qualityUrl: 'https://quality-testing02.input4you.be',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
